<script>
  /**
   *  Mirror.svelte
   * ------------------------------------------------------------------
   * The large circle element used for Mirror, PhotoBooth, and Cartoon
   *
   */

  import { createEventDispatcher } from 'svelte';
  import { scale, fade, blur } from 'svelte/transition';
  import { onMount, onDestroy } from 'svelte';

  const dispatch = createEventDispatcher();

  export let stream,
    inParams = { delay: 0, duration: 0 },
    outParams = { delay: 0, duration: 0 };

  let canvasEl, videoEl, playing;

  onMount(() => {
    console.log('inParams', inParams);

    videoEl.src = stream;
    canvasEl.width = 400;
    canvasEl.height = 400;
    const context = canvasEl.getContext('2d');
    playVideo();

    function drawFrame() {
      try {
        context.drawImage(videoEl, -50, -40, 500, 500);
        playing = requestAnimationFrame(drawFrame);
      } catch (err) {
        console.error(err);
      }
    }
    function playVideo() {
      videoEl.play();
      requestAnimationFrame(drawFrame);
    }
  });

  onDestroy(() => {
    cancelAnimationFrame(playing);
  });

  function stopVideo() {
    cancelAnimationFrame(playing);
    dispatch('cartoonEnded');
  }
</script>

<div
  id="Cartoon"
  class="absolute left-1/2 top-1/2"
  style="width: 416px; height: 416px; margin-left: -208px; margin-top: -208px"
  in:scale="{inParams}"
  out:scale="{outParams}">
  <canvas
    class="border-gray-400 border-8 rounded-full"
    style="mask-image: -webkit-radial-gradient(circle, white 100%, black 100%); overflow-hidden"
    bind:this="{canvasEl}"></canvas>
  <video
    class="hidden rounded-full"
    style="border: 8px solid transparent"
    bind:this="{videoEl}"
    on:ended="{stopVideo}"></video>
</div>
